type LovableErrorOptions = {
  mechanism?: "manual" | "onerror" | "unhandledrejection" | "react_error_boundary";
  handled?: boolean;
  severity?: "error" | "warning" | "info";
};

type LovableEvents = {
  captureException?: (
    error: unknown,
    context?: Record<string, unknown>,
    options?: LovableErrorOptions,
  ) => void;
};

declare global {
  interface Window {
    __lovableEvents?: LovableEvents;
  }
}

import { captureException as captureMonitoringException } from "./monitoring";

export function reportLovableError(error: unknown, context: Record<string, unknown> = {}) {
  // Forward to the pluggable monitoring provider (Sentry/stub) so
  // production integrations receive frontend errors alongside the built-in
  // Lovable capture channel.
  try {
    captureMonitoringException(error, {
      source: "frontend",
      location: typeof window !== "undefined" ? window.location.pathname : undefined,
      extra: context,
      severity: "error",
    });
  } catch {
    // never let monitoring break the boundary
  }

  if (typeof window === "undefined") return;
  window.__lovableEvents?.captureException?.(
    error,
    {
      source: "react_error_boundary",
      route: window.location.pathname,
      ...context,
    },
    {
      mechanism: "react_error_boundary",
      handled: false,
      severity: "error",
    },
  );
}
